import {consumeSsoHandoff} from './app/shared/utils/auth/sso-handoff';

// main.ts imports this first: the store's initial state reads the token from local storage as soon
// as its module loads (core/store/auth/auth.state.ts), so the hand-off has to be stored before that.
consumeSsoHandoff();
